var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDireccion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9492 1.66991C15.8496 2.49022 9.85349 7.15819 7.38279 13.7891C6.48435 16.2012 6.21091 18.0469 6.27927 21.0449C6.36716 24.2773 6.87498 26.6406 8.15427 29.7949C10.6836 35.9961 16.0937 42.4414 22.8418 47.3047C24.2285 48.3008 24.6679 48.5058 25.2344 48.3984C25.7812 48.291 27.6562 46.9726 29.834 45.1562C37.6562 38.6523 42.5097 30.8887 43.5058 23.291C43.7011 21.7773 43.7011 18.9258 43.5058 17.6367C43.0273 14.5019 41.8164 11.5723 39.9511 9.08202C39.2773 8.17382 37.6758 6.51366 36.7676 5.7617C32.998 2.67577 27.7539 1.12303 22.9492 1.66991ZM27.0312 11.2305C30.1074 12.0996 32.4316 14.8437 32.6953 17.9199C33.0469 21.8359 30.7324 25.2148 26.9824 26.2891C25.8984 26.6016 24.0039 26.6016 22.9199 26.2891C20.3613 25.5566 18.4472 23.75 17.539 21.2109C17.2461 20.3906 17.2363 20.3027 17.2363 18.75C17.2363 17.1973 17.2461 17.1094 17.539 16.2891C18.5449 13.4766 20.791 11.5723 23.7109 11.0351C24.4531 10.8984 26.2304 10.9961 27.0312 11.2305Z",
    fill: "#0885C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDireccion);
export default __webpack_public_path__ + "static/media/Direccion.50608a93020df9567caf5dc7965a1339.svg";
export { ForwardRef as ReactComponent };